__turbopack_context__.v({
  "fieldset": "Fieldset-module-scss-module__2G_C7G__fieldset",
  "fieldset__asterisk": "Fieldset-module-scss-module__2G_C7G__fieldset__asterisk",
  "fieldset__inner": "Fieldset-module-scss-module__2G_C7G__fieldset__inner",
  "fieldset__legend": "Fieldset-module-scss-module__2G_C7G__fieldset__legend",
});
